import React from 'react'
import Header from "../../../../Components/Header";
import BankAccount from './BankAccount';
import { Helmet } from 'react-helmet';
function ViewBankAccount() {
    return (
        <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
            <Helmet>
                <title>Bank Account - Create</title>
            </Helmet>
            <Header />
            <div className="container-fluid maindiv d-flex flex-column " style={{ flexGrow: '1' }}>
                <BankAccount />
            </div>
        </div>
    )
}

export default ViewBankAccount
